"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractPlatformService = _interopRequireDefault(require("../AbstractPlatformService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class handles platform with the ROIG application through post message.
 */
var RoigPlatformService = /*#__PURE__*/function (_AbstractPlatformServ) {
  _inherits(RoigPlatformService, _AbstractPlatformServ);

  var _super = _createSuper(RoigPlatformService);

  function RoigPlatformService() {
    _classCallCheck(this, RoigPlatformService);

    return _super.apply(this, arguments);
  }

  _createClass(RoigPlatformService, [{
    key: "setContainerSize",

    /**
     * Sets the iframe container height.
     *
     * @param {Number} height Height to set.
     * @return {Promise} Promise object.
     */
    value: function setContainerSize(height) {
      var _this = this;

      return new Promise(function (resolve) {
        if (_this.isInsideIframe()) {
          window.parent.postMessage({
            method: 'setHeight',
            parameters: {
              height: height
            }
          }, '*');
        }

        resolve();
      });
    }
    /**
     * Adds items to shopping bag.
     *
     * @param {String} items List of items.
     * @param {String} vpcCode VPC code.
     * @return {Promise} Promise object.
     */

  }, {
    key: "addToShoppingBag",
    value: function addToShoppingBag(items, vpcCode) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (_this2.isInsideIframe()) {
          window.parent.postMessage({
            method: 'addToShoppingBag',
            parameters: {
              items: items.map(function (item) {
                return {
                  ID: item.id,
                  Type: item.type,
                  Qty: item.qty
                };
              }),
              vpcCode: vpcCode
            }
          }, '*');
        }

        resolve();
      });
    }
    /**
     * Sets the cart count.
     *
     * @param {Number} cartCount Cart count to set.
     * @return {Promise} Promise object.
     */

  }, {
    key: "setCartCount",
    value: function setCartCount(cartCount) {
      var _this3 = this;

      return new Promise(function (resolve) {
        if (_this3.isInsideIframe()) {
          window.parent.postMessage({
            method: 'setCartCount',
            parameters: {
              cartCount: cartCount
            }
          }, '*');
        }

        resolve();
      });
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @return {String} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'roigplatform';
    }
  }]);

  return RoigPlatformService;
}(_AbstractPlatformService.default);

exports.default = RoigPlatformService;